/* raw layout hash: _default-web-layout-3rhmrt:8bd20b0007cced3f422b1ee786601a4766bc0af79cbdaf7337abe7cf7cf26e94 */
import React from 'react';
import AppShell from './AppShell.jsx';
import { LAYOUT_MENUS } from './layoutMenus.js';

// Layout "_default-web-layout-3rhmrt" — renders its page content through the router outlet.
export default function DefaultWebLayout3rhmrt() {
  return <AppShell layoutName="_default-web-layout-3rhmrt" menu={LAYOUT_MENUS['_default-web-layout-3rhmrt']} />;
}
